import React from "react";
import { ModeRendererProps } from "./types";

export function FirewallMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <rect x="0" y="0" width="794" height="1123" fill="url(#brick)" />
      <g transform="translate(397 540)">
        <use href="#shield" fill={brand.deep} stroke={brand.amber} strokeWidth="8" />
        <use href="#shield" fill="none" stroke={brand.white} strokeWidth="3" transform="scale(0.86)" />
        <g>
          <path d="M-90 10 H90" stroke={brand.aqua} strokeWidth="8" />
          <path d="M0 -80 V150" stroke={brand.violet} strokeWidth="8" />
        </g>
      </g>
    </g>
  );
}
